import React from "react";

interface InputProps {
  type: "text" | "password" | "date" | "number" | "email";
  value?: any;
  variant?: "outlined" | "filled" | "standard";
  label?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  readonly?: boolean;
  text?: string | number;
  icon?: React.ReactNode;
  error?: boolean;
  isNewError?: boolean;
}

const TextField: React.FC<InputProps> = ({
  type,
  error,
  isNewError,
  label,
  value,
  variant = "outlined",
  placeholder,
  disabled = false,
  readonly = false,
  text,
  icon,
  onChange,
}) => {
  const InputClass = () => {
    let baseClass = `pl-2 w-[230px] h-[30px] text-black font-sans`;
    let errorClass =
      error || isNewError ? "border border-red-500" : "border-slate-300";

    switch (variant) {
      case "outlined":
        return `${baseClass} rounded ${errorClass}`;
      case "filled":
        return `${baseClass} border-b rounded-t border-slate-600 bg-slate-300 ${
          error || isNewError ? "bg-red-50" : ""
        }`;
      case "standard":
        return `${baseClass} border-b border-slate-600 ${errorClass}`;
      default:
        return baseClass;
    }
  };

  return (
    <div className="flex flex-col relative text-custom-micro w-full">
      {label && (
        <label className="pl-1 pb-1 font-semibold ">
          {label}{" "}
          {isNewError && <span className="text-red-500">*Required</span>}{" "}
          {error && (
            <span className="text-red-500">*Password does not match!</span>
          )}
        </label>
      )}
      {readonly ? (
        <p className="pl-2">{text || value}</p>
      ) : (
        <>
          <input
            type={type}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readonly}
            onChange={onChange}
            className={`${InputClass()} ${
              isNewError ? "border border-red-500" : ``
            }`}
          />

          {icon && (
            <span
              className={`absolute right-2 top-1/2 transform -translate-y-1/2 ${
                error ? "mt-1" : "mt-3.5"
              } ${
                isNewError ? "" : "mt-1"
              } mr-2 text-black hover:text-red-600 hover:scale-125`}
            >
              {icon}
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default TextField;
